export default "__VITE_ASSET__48919eda__"